import React from 'react';

const withBookingStage = (Component: React.FC) => (props: any) => {
  const show = props.show;

  return <>{show ? <Component {...props} /> : null}</>;
};
export default withBookingStage;
